// Angular
import { inject } from '@angular/core';
import { HttpEvent, HttpRequest, HttpErrorResponse, HttpInterceptorFn, HttpHandlerFn } from '@angular/common/http';
// RxJS
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
// Services
import { NotificationService } from './notification.service';

export const ErrorInterceptor: HttpInterceptorFn = (request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {

    const notificationService = inject(NotificationService);

    return next(request).pipe(
        catchError((error: HttpErrorResponse) => {
            // Check if it's a 5xx server error
            if (error.status >= 500 && error.status < 600) {
                const errorMessage = 'A technical error has occurred. Our team has been notified. Please try again later.';

                // Use the notification service to show the error message to the user
                notificationService.showError(errorMessage);
            }

            // IMPORTANT: Re-throw the error so that component-level error handlers
            // (if any) can also catch it.
            return throwError(() => error);
        })
    );
};